import { createStore } from 'vuex';
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';
import router from '@/router';
import moment from 'moment';
import Api from '../api/Api';
import DOMPurify from 'dompurify';
import { useRoute, useRouter } from 'vue-router';
import { getDefaultEnvironment } from '@/utils/getDefaultEnvironment';
import axios from 'axios';
import { getBaseUrls } from "@/utils/getBaseUrls";
const { inboxBaseURL } = getBaseUrls();
const getParentLibId = () => {
  let locationUrl = new URL(document.location.href);
  if (locationUrl.searchParams.get('p')) {
    return locationUrl.searchParams.get('p');
  } else {
    return localStorage.getItem('parent_lib_id');
  }
};

const areThirdPartyCookiesEnabled = () => {
  // Try to set a third-party cookie
  document.cookie = 'testCookie=test; samesite=None; secure';

  // Check if the cookie was set successfully
  var cookiesEnabled = document.cookie.indexOf('testCookie') !== -1;

  // Clean up by deleting the test cookie
  document.cookie = 'testCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; samesite=None; secure';

  return cookiesEnabled;
};

function clearConversationUnreadState(state, conversation_ref) {
  const ref = conversation_ref?.toString();
  if (!ref) return;
  const listKeys = [
    'inboxMembers', 'inboxTickets', 'tickets', 'otherTickets', 'hlptTickets',
    'mentionTickets', 'createdByYouTickets', 'reassignedTickets', 'unassignedTickets',
    'awaitingReplyTickets', 'awaitingReplyHlptTickets', 'drafts', 'archiveChats', 'searchRecords',
  ];
  listKeys.forEach((key) => {
    const list = state[key];
    if (!Array.isArray(list)) return;
    const index = list.findIndex((el) => el?.conversation_ref?.toString() === ref);
    if (index !== -1) {
      list[index] = { ...list[index], unread_messages_count: 0 };
    }
  });
  const flagKeys = [
    'ticketsNotifyFlag', 'otherTicketsNotifyFlag', 'hlptTicketsNotifyFlag',
    'awaitingReplyHlptTicketsNotifyFlag', 'unassignedTicketsNotifyFlag',
    'reassignedTicketsNotifyFlag', 'createdByYouTicketsNotifyFlag',
  ];
  flagKeys.forEach((key) => {
    const flags = state[key];
    if (!Array.isArray(flags)) return;
    const index = flags.findIndex((el) => el?.toString() === ref);
    if (index !== -1) flags.splice(index, 1);
  });
  state.tickets = [...(state.tickets || [])];
  state.inboxTickets = [...(state.inboxTickets || [])];
  const currentKey = Number(state.renderChats?.key) || 0;
  state.renderChats = {
    type: 'inboxTickets',
    key: currentKey + 1,
  };
}

export default createStore({
  state: {
    channel: null,
    activeTab: false,
    widgetPulseChannelTimeout: null,
    widgetPulseChannelInterval: null,
    isChannelStarted: false,
    conversation_review:'',
    isAgentProfileNotCompleted: false,
    isChildLibrariesLoading: false,
    isSelectedChildAgency: null,
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isRTL: false,
    color: '',
    sidebarType: 'bg-white',
    darkMode: false,
    demoMode: (() => {
      const localDemoMode = localStorage.getItem('demo_mode');
      if (localDemoMode) {
        return localDemoMode === 'true';
      }
      return ['staging'].some(env => window.location.hostname.includes(env));
    })(),
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: 'default',
    siteCopyRight: '',
    childLibraryList: [],
    assigned_lib_id: localStorage.getItem('parent_lib_id') == process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID ? localStorage.getItem('parent_lib_id') : '',

    user_id: localStorage.getItem('user_id'),
    support_lib_id: localStorage.getItem('support_Lib_id'),
    ticketStatusUpdatingRef: '',
    externalRefUpdatingRef: '',

    createdByTicketsSupportFilter:'',
    ticketsSupportFilter:'',
    otherTicketsSupportFilter:'',
    reassignedTicketsSupportFilter:'',
    unassignedTicketsSupportFilter:'',
    awaitingReplyTicketsSupportFilter:'',
    awaitingReplyHlptTicketsSupportFilter:'',
    searchSupportFilter:'',

    ticketsTicketTypeFilter:'',
    otherTicketsTicketTypeFilter:'',
    hlptTicketsTicketTypeFilter:'',
    createdByYouTicketsTicketTypeFilter:'',
    unassignedTicketsTicketTypeFilter:'',
    reassignedTicketsTicketTypeFilter:'',
    awaitingReplyTicketsTicketTypeFilter:'',
    awaitingReplyHlptTicketsTicketTypeFilter:'',
    searchTicketTypeFilter:'',

    updateReportSidebar: false,

    newReport: null,
    selectedChart: null,

    selectedChildAgencyFilter: '',
    agent_picture: '',
    frontendUnreadMsgs: 0,
    selectedEnvironmentId: null,
    selectedEnvironment: null,
    environments: [],
    queueMembers: [],
    queueTickets: [],
    queueTicketsTotalCount: 0,
    queueTicketsLimit: 75,
    inboxMembers: [],
    messages: {},
    selectedChatBefore: null,
    selectedChat: null,
    selectedOngoingChat: null,
    selectedArchive: null,
    selectedTicket: null,
    selectedOtherTicket: null,
    selectedMentionTicket: null,
    selectedCreatedByYouTicket: null,
    selectedReassignedTicket: null,
    selectedUnassignedTicket: null,
    selectedAwaitingReplyTicket: null,
    selectedHlptTicket: null,
    isSelectedChatLoading: false,
    isSelectedArchiveLoading: false,
    isSelectedTicketLoading: false,
    isSelectedOtherTicketLoading: false,
    isSelectedMentionTicketLoading: false,
    isSelectedCreatedByYouTicketLoading: false,
    isSelectedReassignedTicketLoading: false,
    isSelectedUnassignedTicketLoading: false,
    isSelectedAwaitingReplyTicketLoading: false,
    isSelectedSearchLoading: false,
    isSelectedOtherHlptTicketLoading: false,
    isSelectedAwaitingReplyHlptTicketLoading: false,
    isAiWidget: 0,

    openIntegratedChats: false,

    socket: '',
    /** True while the widget chat WebSocket has connected (onopen); false after close/clear */
    widgetChatSocketOpen: false,
    scrollToBottom: false,
    display_name: '',
    debugging_mode: false,
    isticketCreating: false,
    isticketTypeCreating: false,
    isDirectTicketCreating: false,

    isArchiveSearch: false,
    searchArchive: false,
    isArchiveSearching: false,
    archiveSortByFilter: 'newest',
    archiveEmailFilter: '',
    archivePerpage: 20,
    allChatsSortByFilter: '',
    archiveChatsTotalRecords: 0,
    archiveChatsPage: 1,
    archiveChats: [],

    inboxChatsType: 'all',

    isDisplayInboxChats: true,
    isDisplaySuperviseChats: true,
    isDisplayInboxTickets: true,

    /* Tickets assigned to the logged in agent, listed under the inbox tab's "My Tickets" section.
       Kept separate from the My Tickets tab state so both can be paged independently. */
    inboxTickets: [],
    inboxTicketsTotalRecords: 0,
    inboxTicketsPage: 1,
    inboxTicketsPerpage: 20,
    fetchInboxTickets: false,
    isLoadingInboxTickets: false,
    /* Resolved/reassigned refs excluded from inbox My Tickets until the API catches up. */
    inboxTicketsHiddenRefs: [],

    superviseChats: {},
    allOnGoingChats: [],
    isSuperviseChatsLoading: true,
    isAllOnGoingChatsLoading: true,

    ticketsTotalRecords: 0,
    ticketsPage: 1,
    isTicketSearch: false,
    searchTicket: false,
    isTicketSearching: false,
    ticketSortByFilter: 'newest',
    ticketEmailFilter: '',
    ticketStatusByFilter: '',
    ticketCategoryFilter: '',
    ticketTierFilter: '',
    ticketCreateMethodFilter: '',
    ticketLastMessageSenderFilter: '',
    ticketRefFilter: '',
    ticketCreateStatusFilter: '',
    ticketsPerpage: 20,
    tickets: [],
    fetchTickets: false,
    isLoadingTickets: false,

    otherTicketsTotalRecords: 0,
    otherTicketsPage: 1,
    isOtherTicketSearch: false,
    searchOtherTicket: false,
    isOtherTicketSearching: false,
    otherTicketSortByFilter: 'newest',
    otherTicketEmailFilter: '',
    otherTicketStatusByFilter: '',
    otherTicketCategoryFilter: '',
    otherTicketTierFilter: '',
    otherTicketCreateMethodFilter: '',
    otherTicketLastMessageSenderFilter: '',
    otherTicketRefFilter: '',
    otherTicketCreateStatusFilter: '',
    otherTicketsPerpage: 20,
    otherTickets: [],
    fetchOtherTickets: false,
    isLoadingOtherTickets: false,
    otherTicketsAssignedFilter: '',

    hlptTicketsTotalRecords: 0,
    hlptTicketsPage: 1,
    isHlptTicketSearch: false,
    searchHlptTicket: false,
    isHlptTicketSearching: false,
    hlptTicketSortByFilter: 'newest',
    hlptTicketEmailFilter: '',
    hlptTicketStatusByFilter: '',
    hlptTicketCategoryFilter: '',
    hlptTicketTierFilter: '',
    hlptTicketCreateMethodFilter: '',
    hlptTicketRefFilter: '',
    hlptTicketCreateStatusFilter: '',
    hlptTicketsPerpage: 20,
    hlptTickets: [],
    fetchHlptTickets: false,
    isLoadingHlptTickets: false,

    mentionTicketsTotalRecords: 0,
    mentionTicketsPage: 1,
    isMentionTicketSearch: false,
    searchMentionTicket: false,
    isMentionTicketSearching: false,
    mentionTicketSortByFilter: 'newest',
    mentionTicketEmailFilter: '',
    mentionTicketStatusByFilter: '',
    mentionTicketCategoryFilter: '',
    mentionTicketTierFilter: '',
    mentionTicketCreateMethodFilter: '',
    mentionTicketsTicketTypeFilter: '',
    mentionTicketRefFilter: '',
    mentionTicketCreateStatusFilter: '',
    mentionTicketsPerpage: 20,
    mentionTickets: [],
    mentionFilterBy: 'unread',
    fetchMentionTickets: false,
    isLoadingMentionTickets: false,

    createdByYouTicketsTotalRecords: 0,
    createdByYouTicketsPage: 1,
    isCreatedByYouTicketSearch: false,
    searchCreatedByYouTicket: false,
    isCreatedByYouTicketSearching: false,
    createdByYouTicketSortByFilter: 'newest',
    createdByYouTicketEmailFilter: '',
    createdByYouTicketStatusByFilter: '',
    createdByYouTicketCategoryFilter: '',
    createdByYouTicketTierFilter: '',
    createdByYouTicketCreateMethodFilter: '',
    createdByYouTicketRefFilter: '',
    createdByYouTicketCreateStatusFilter: '',
    createdByYouTicketsPerpage: 20,
    createdByYouTickets: [],
    fetchCreatedByYouTickets: false,
    isLoadingCreatedByYouTickets: false,

    reassignedTicketsTotalRecords: 0,
    reassignedTicketsPage: 1,
    isReassignedTicketSearch: false,
    searchReassignedTicket: false,
    isReassignedTicketSearching: false,
    reassignedTicketSortByFilter: 'newest',
    reassignedTicketEmailFilter: '',
    reassignedTicketStatusByFilter: '',
    reassignedTicketCategoryFilter: '',
    reassignedTicketTierFilter: '',
    reassignedTicketCreateMethodFilter: '',
    reassignedTicketRefFilter: '',
    reassignedTicketCreateStatusFilter: '',
    reassignedTicketsPerpage: 20,
    reassignedTickets: [],
    fetchReassignedTickets: false,
    isLoadingReassignedTickets: false,

    unassignedTicketsTotalRecords: 0,
    unassignedTicketsPage: 1,
    isUnassignedTicketSearch: false,
    searchUnassignedTicket: false,
    isUnassignedTicketSearching: false,
    unassignedTicketSortByFilter: 'newest',
    unassignedTicketEmailFilter: '',
    unassignedTicketStatusByFilter: '',
    unassignedTicketCategoryFilter: '',
    unassignedTicketTierFilter: '',
    unassignedTicketCreateMethodFilter: '',
    unassignedTicketRefFilter: '',
    unassignedTicketCreateStatusFilter: '',
    unassignedTicketsPerpage: 20,
    unassignedTickets: [],
    fetchUnassignedTickets: false,
    isLoadingUnassignedTickets: false,

    awaitingReplyTicketsTotalRecords: 0,
    awaitingReplyTicketsPage: 1,
    isAwaitingReplyTicketSearch: false,
    searchAwaitingReplyTicket: false,
    isAwaitingReplyTicketSearching: false,
    awaitingReplyTicketSortByFilter: 'newest',
    awaitingReplyTicketEmailFilter: '',
    awaitingReplyTicketStatusByFilter: '',
    awaitingReplyTicketCategoryFilter: '',
    awaitingReplyTicketTierFilter: '',
    awaitingReplyTicketCreateMethodFilter: '',
    awaitingReplyTicketLastMessageSenderFilter: 'visitor',
    awaitingReplyTicketRefFilter: '',
    awaitingReplyTicketCreateStatusFilter: '',
    awaitingReplyTicketsPerpage: 20,
    awaitingReplyTickets: [],
    fetchAwaitingReplyTickets: false,
    isLoadingAwaitingReplyTickets: false,

    draftsTotalRecords: 0,
    isSelectedDraftLoading: false,
    draftsPage: 1,
    draftsPerPage: 20,
    fetchDrafts: false,
    fetchDraftsList: false,
    isLoadingDrafts: false,
    drafts: [],
    draftReviewFor: 'self',
    draftReviewStatus: '',
    selectedDraft: null,
    draftEmailFilter: '',
    isDraftSearch: false,
    isDraftSearching: false,
    searchDraft: false,

    awaitingReplyHlptTicketsTotalRecords: 0,
    awaitingReplyHlptTicketsPage: 1,
    isAwaitingReplyHlptTicketSearch: false,
    searchAwaitingReplyHlptTicket: false,
    isAwaitingReplyHlptTicketSearching: false,
    awaitingReplyHlptTicketSortByFilter: 'newest',
    awaitingReplyHlptTicketEmailFilter: '',
    awaitingReplyHlptTicketStatusByFilter: '',
    awaitingReplyHlptTicketCategoryFilter: '',
    awaitingReplyHlptTicketTierFilter: '',
    awaitingReplyHlptTicketCreateMethodFilter: '',
    awaitingReplyHlptTicketLastMessageSenderFilter: 'visitor',
    awaitingReplyHlptTicketRefFilter: '',
    awaitingReplyHlptTicketCreateStatusFilter: '',
    awaitingReplyHlptTicketsPerpage: 20,
    awaitingReplyHlptTickets: [],
    fetchAwaitingReplyHlptTickets: false,
    isLoadingAwaitingReplyHlptTickets: false,

    

    fetchByTicketConversationRef: '',

    searchTotalRecords: 0,
    searchPage: 1,
    isSearch: false,
    searchTicket: false,
    isSearching: false,
    searchSortByFilter: '',
    searchEmailFilter: '',
    searchStatusByFilter: '',
    searchCategoryFilter: '',
    searchTagFilter: '',
    searchTierFilter: '',
    searchCreateMethodFilter: '',
    searchTicketRefFilter: '',
    searchCreateStatusFilter: '',
    searchPerpage: 20,
    searchRecords: [],
    searchCompanyFilter: null,
    searchCtFromFilter: '',
    searchCtToFilter: '',
    searchCustomerNameFilter: '',
    searchExternalRefFilter: '',
    searchCustomerEmailFilter: '',
    filterSearchCompanies: '',
    filterSearchTeammates: '',
    filterSearchCategory: '',
    filterSearchTag: '',
    searchDateFilter: '',
    searchDateSelectedFilter: '',
    searchFilterType: '',
    searchTicketConversationRefFilter: '',
    selectedSearch: {},
    searchQuery: '',
    searchTicketAssignedTo: '',
    searchAgentTypeFilter: '',
    searchCSATFilter: [],
    searchDate: [],
    initSearchRecords: false,
    fetchSearchRecords: false,
    searchAdditionalFilters: [],

    assignmentAgentList: [],
    isAssignmentAgentListLoading: [],

    isChatTakeOverProcessing: false,
    isTicketAssignmentLoading: null,

    isAddingLeadTags: false,
    isLoadingLeadTags: false,
    tags: [],
    isLoadingArchieve: false,
    is_away: null,
    awayAgents: [],
    agentModeUpdated: false,

    isThreadLoading: false,
    threadLoadGeneration: 0,

    internet_connection: 'online',
    show_internet_alert: false,

    newConnectionInterval: null,
    pulseInterval: null,

    selectedChats: [],

    //frontend chat
    isModalChat: false,
    chatStarted: localStorage.getItem('chatStarted') == 'true' ? true : false,
    initChat: null,
    isChatConnecting: false,
    isModalChatStarted: false,
    previousChat: [],
    frontendMessages: [],
    connection_id: '',
    chatClosing: false,
    widgetChatForm: false,
    companyName: 'Chat',
    frontendCompanyName: 'Knowledge Base',
    companyLogo: '',
    visitor_name: areThirdPartyCookiesEnabled() ? localStorage.getItem('visitor_name') : '',
    visitor_email: areThirdPartyCookiesEnabled() ? localStorage.getItem('visitor_email') : '',
    visitor_question: '',
    conv_rating: '',
    /** When true, CSAT / inline rating-request UI may be shown. Set false after submit; reset true on new chat. */
    showSubmitCsatButton: false,
    isConnecting: false,
    isTyping: false,
    areThirdPartyCookiesEnabled: false,
    visitor_connection_conversation_ref: '',
    visitor_connection_agent_ref: '',
    visitor_connection_queue_ref: '',
    visitor_connection_device_ref: '',
    visitor_connection_visitor_ref: '',
    visitor_connection_visitor_con_id: '',
    fetchArchives: false,
    agent_name: '',
    agentList: [],
    allAgentList: [],
    isPreviousMessagesFetching: false,
    isMarkingSeen: false,
    markAsSeenTimeOut: null,

    showCompactBottomToolbar: true,

    widgetDashboard: null,
    widgetMessages: null,
    widgetContactus: null,
    widgetHelplibrary: null,
    widgetNewsfeed: null,

    isOtherTicketMenuLinkFlagged: false,
    isArchivesMenuLinkFlagged: false,
    isHlptTicketMenuLinkFlagged: false,
    isAwaitingHlptTicketMenuLinkFlagged: false,

    advancedWidgetIndex: 'HomeAdvancedDashboard',
    advancedWidgetActiveRoute: 'HomeAdvancedDashboard',
    compactWidgetActiveRoute: 'HomeAdvancedDashboard',
    customLinkData: null,
    selectAllRecords: false,
    isUserPermissionsLoading: true,
    queueListView: true,
    engageListView: true,
    dashboardListView: true,
    dashboardSupportFilter: 'all',
    dashboardDepartmentIds: [],
    inboxTicketTypes: [],
    inboxDepartments: [],
    dashboardPanelContentFilters: {
        left: 'all',
        right: 'all',
    },
    dashboardTicketTypeIdFilters: {
        left: [],
        right: [],
    },
    dashboardTicketMethodFilters: {
        left: [],
        right: [],
    },
    dashboardSelectedMetric: null,
    queueConvTypeFilter: null,
    queueTicketTypeFilter: [],
    ticketsListView: true,
    otherTicketsListView: true,
    awaitingReplyHlptTicketsListView: true,
    awaitingReplyTicketsListView: true,
    createdByYouTicketsListView: true,
    hlptTicketsListView: true,
    reassignedTicketsListView: true,
    draftsListView: true,
    unassignedTicketsListView: true,
    userPermissions: {
      canManageGeneralAndSecuritySettings: true,
      canManageTeammatesSeatsAndPermissions: true,
      canChangeTeammatesStatus: true,
      canManageMessengerSettings: true,
      canManageWidgetSettings: true,
      canManageTicketSettings: true,
      canManageChatSettings: true,
      canCreateAndUpdateHelpCenterArticles: true,
      canManageAndPublishHelpCenterArticles: true,
      canCreateAndUpdateNewsArticles: true,
      canManageAndPublishNewsArticles: true,
      canCreateAndUpdateCoursesArticles: true,
      canManageAndPublishCoursesArticles: true,
      canCreateAndUpdateSopArticles: true,
      canManageAndPublishSopArticles: true,
      canTakeChats: true,
      canSuperviseChats: true,
      canViewChatArchives: true,
      canReplyToTickets: true,
      canViewExistingTickets: true,
      canCreateAndEditAnAutomation: true,
      canInviteNewUsers: true,
      canUpdateUserRoles: true,
      canReviewOtherDrafts: true,
      canSubmitTicketForReview: true,
      canDeleteOrReassignOwner: true,
      canCreateAndEditForms: true,
      canCreateAndEditReports: true,
      canViewReports: true,
      canViewForms: true,
      canViewAutomations: true,
      canCreateAndEditIntegrations: true,
      canViewIntegrations: true,
      canAssignChats: true,
      canDeleteAnAutomation: true,
      canCreateAndEditSmartQueue: true,
      canDeleteSmartQueue: true,
      canViewModalaiCommonInstructions: true,
      canUpdateModalaiCommonInstructions: true,
      canViewModalaiSystemInstructions: true,
      canUpdateModalaiSystemInstructions: true,
      canViewModalaiCustomDocs: true,
      canSubmitModalaiCustomDocs: true,
    },

    agent_role: localStorage.getItem('user_type'),

    renderChart: false,
    showConversationDetails_open: false,
    customFormRef: false,
    selected_contact_form_ref: '',
    fetchTeams: false,
    customFormFields: [],
    isCustomFormLoading: false,
    customFormBuilderObject: null,

    chat_ref_uid: '',
    chat_ended_by: '',
    showToast: {},
    printConsoleLogs: {},
    enable_inbox_notifications: true,

    draft_messages: [],
    draft_statuses: [],

    parent_lib_id: getParentLibId(),
    bootstrap,
    lastFailedArticleSearch: {
      id: '',
    },
    lastSuccessArticleSearch: {
      id: '',
    },
    searchedKeyword: {
      query: '',
    },
    isYourReportsSelected: '',
    conv_ticket_rating: '',

    autoAssignedChatThreads: [],
    autoAssignedChatThreadsInterval: null,

    manualAssignedChatThreads: [],
    manualAssignedChatThreadsInterval: null,

    activityFeedsInterval: null,

    assignment_wait_time: 1,

    chatClosedByUser: false,

    queueOrderBy: '',
    queueOrder: '',

    engageOrderBy: '',
    engageOrder: '',

    ticketOrderBy: '',
    ticketOrder: '',

    queueMembersLoading: [],
    takeOverFromAiLoading: [],
    superviseChatsLoading: [],
    queueTicketAssigningRefs: [],

    smartSearchLists: [],

    team_names: [],
    queuesFilter:'',
    engageFilter:'',

    selected_support_lib_id: '',
    isUserLoggedIn: false,
    refKey: null,

    renderChats: {
      type: '',
      key: 1,
    },

    // Add new reports state
    reports: {
      allReports: [],
      lastUpdated: null,
    },

    company_name:'',

    pulseTimeout: null,
    pulseTimeoutConnectionRetires: 0,
    showAssignmentPendingDialogTimeout: null,
    showAssignmentPendingDialog: false,
    activityFeeds: [],
    assigned_lib_id_agent_list:[],
    totalActivityFeeds: 0,
    priority_assignment_pending_msg: '',
    priority_assignment_pending_minutes: 0,
    chatDrafts: {
      inbox: {},
      search: {},
      archives: {},
      tickets: {},
      mentiontickets: {},
      hlpttickets: {},
      createdbyyoutickets: {},
      othertickets: {},
      reassignedtickets: {},
      unassignedtickets: {},
      awaitingreplytickets: {},
      awaitingreplyhlpttickets: {},
      drafts: {},
    },
    chatMessageType: {
      inbox: {},
      search: {},
      archives: {},
      tickets: {},
      mentiontickets: {},
      hlpttickets: {},
      createdbyyoutickets: {},
      othertickets: {},
      reassignedtickets: {},
      unassignedtickets: {},
      awaitingreplytickets: {},
      awaitingreplyhlpttickets: {},
      drafts: {},
    },
    isUserTyped: true,
    isUserTyping: false,
    isWidgetRefreshing: false,
    isRestoringPreviousConnection: false,
    socket_connection_closed: false,
    isSocketConnectionRegenerating: false,
    isSocketReconnect: false,
    fetchTags: false,
    newChart: null,
    refresh_reason: '',
    socketStatus: function (ws) {
      switch (ws?.readyState) {
        case ws?.CONNECTING: // 0
          return 'connecting'; // Socket created but not yet connected
        case ws?.OPEN: // 1
          return 'open'; // Connection ready for communication
        case ws?.CLOSING: // 2
          return 'closing'; // Connection is in process of closing
        case ws?.CLOSED: // 3
          return 'closed'; // Connection is closed or failed
        default:
          return 'unknown';
      }
    },
    message_queue: [],
    showLogsModal: false,
    logsModalUrl: '',
    socketErrorRetries: 0,
    chat_closed: false,
    closeChatSwalTimeout: null,
    isSocketReconnecting: false,
    socket_msg_response: null,
    animationFrameId: null,
    pulseWorker: null,
    chat_ended_message: '',

    lastUpdatedDate: [],
    lastUpdatedDateFilter:'',
    lastUpdatedStartDateFilter: '',
    lastUpdatedEndDateFilter: '',
    redactorInputBoxData: '',
    redactorApp: null,

    init_support_lib_id:'',
    removeEventListeners:false,

    isSocketReleased: false,

    isChatListScrollEnabled: true,

    fetchAgents:false,

    reconnectDelay: 1000, // Initial delay: 1 second
    maxRetries: 5,
    reconnectLock: false,
    isAway: false,

    resetChat: false,

    showDirectTicketModal: false,

    isAtBottom: false,

    library_domain: '',
    library_refkey: '',
    isPermissionsFetched:false,
    priority_cta_text: '',
    priority_start_text: '',
    priority_cta_bg: '',
    priority_text_bg: '',
    priority_cta_color: '',
    priority_text_color: '',

    isLibrarySwitching: false,

    ignoreNotificationIds:[],

    widgetContentLoading: true,
    widgetDashboardCategories: [],

    isWidgetReplySubmitted: false,
    isWidgetReplySubmittedTimeout: null,
    support_lib_cid:'',

    aiTimeouts: [],
    thinkingText: '',

    widget_qp:0,
    widget_aqp:0,

    isTicketTypeUpdating: false,
    ticketTypeUpdatingTimeout: null,
    ticketCreatedMethods: [],
    ticketsNotifyFlag: [],
    otherTicketsNotifyFlag: [],
    hlptTicketsNotifyFlag: [],
    awaitingReplyHlptTicketsNotifyFlag: [],
    unassignedTicketsNotifyFlag: [],
    reassignedTicketsNotifyFlag: [],
    createdByYouTicketsNotifyFlag: [],
    fetchPreviousMessages: false,
    isRequestChatEstimateMsg: null,
    isRequestChatEstimateMsgInterval: null,
    gm_info: '',
    streamingResponses: [],
    /** Status messages from streaming_status socket events (completed steps; each group's last message stays here) */
    streamingStatusMessages: [],
    /** Current group's message shown in the single "replacing" card (cycles through group.messages) */
    currentStreamingGroupMessage: null,
    /** Key of the group currently cycling (e.g. 'Initializing...') */
    currentStreamingGroupKey: null,
    /** Timeout IDs for the replace cycle; cleared when switching groups */
    streamingGroupMessageTimeouts: [],
    /** Buffered streaming_response_chunk content during "Complete" step, keyed by message_id */
    streamingChunkBuffer: {},
    /** message_id for which "Complete" step is currently shown; prevents duplicate Complete steps */
    streamingCompletePendingMessageId: null,
    /** message_id of the agent bubble that is actively streaming (inline caret); null when not streaming */
    streamingChunkActiveMessageId: null,
    isStreamingStarted:false,
    /** Grouping config for streaming status → stack messages (used by AdvancedWidget + HomeAdvancedModalChat) */
    streamMessageGrouping: {
      'Initializing...': {
        messages: [
          'Initiating analysis of your request...', 
          'Understanding the context and scope of your request...', 
          'Preparing to research your query across your data...'
        ],
        group: 'Initializing...',
        timeout: 1000,
      },
      'Searching....': {
        messages: [
          'Scanning the database for records related to your query...', 
          'Identifying key data points associated with your request...', 
          'Organizing retrieved data for further processing...'
        ],
        group: 'Searching....',
        timeout: 1200,
      },
      'Generating response...': {
        messages: [
          'Synthesizing findings to construct a meaningful response...', 
          'Processing a larger set of results to ensure accuracy...', 
          'Compiling the analyzed information into a clear response...', 
          'Finalizing the response for delivery...'
        ],
        group: 'Generating response...',
        timeout: 1400,
      },
      Complete: {
        messages: ['Completing the final response...'],
        group: 'Complete',
        timeout: 400,
      },
    },
    /**
     * Lighter-weight grouping used when the visitor's message looks like a
     * greeting / small-talk (e.g. "hi", "hello", "how are you", "thanks").
     * Tones are friendlier and timeouts are shorter so the cards feel snappy
     * — long "scanning the database" copy doesn't fit a "hello" turn.
     */
    aiChatStreamMessageGrouping: {       
      short: {         
        'Initializing...': {           
          messages: [
            'Processing your query...', 
            'Setting up the conversation...'
            ],           
          group: 'Initializing...',           
          timeout: 3200,         
        },         
        'Searching....': {           
          messages: ['Looking up information for you...'],           
          group: 'Searching....',           
          timeout: 3600,         
        },         
        'Generating response...': {           
          messages: [
            'Assembling relevant information into a response...', 
            'Preparing a quick response...', 
            'Putting together your answer...'
            ],          
           group: 'Generating response...',           
           timeout: 4000,         
        },         
        Complete: {           
          messages: ['Wrapping up the response...'],           
          group: 'Complete',           
          timeout: 1800,         
        },       
      },       
      medium: {         
        'Initializing...': {           
          messages: [
            'Reviewing your input for context...', 
            'Evaluating your request briefly...'
          ],           
          group: 'Initializing...',           
          timeout: 1800,         
        },         
        'Searching....': {           
          messages: ['Gathering information related to your query...'],           
          group: 'Searching....',           
          timeout: 2000,         
        },         
        'Generating response...': {           
          messages: [
            'Formulating a concise answer...', 
            'Assembling relevant information into a response...', 
            'Preparing a quick response...', 
            'Putting together your answer...', 
            'Assembling relevant information into a response...'
            ],           
          group: 'Generating response...',           
          timeout: 2200,         
        },         
        Complete: {           
          messages: ['Finalizing your response...'],           
          group: 'Complete',           
          timeout: 800,         
        },       
      },       
      large: {         
        'Initializing...': {          
          messages: [
            'Initiating analysis of your request...', 
            'Understanding the context and scope of your request...', 
            'Preparing to research your query across your data...'
          ],           
          group: 'Initializing...',           
          timeout: 4000,         
        },         
        'Searching....': {           
          messages: [
            'Scanning the database for records related to your query...', 
            'Identifying key data points associated with your request...', 
            'Organizing retrieved data for further processing...'
          ],           
          group: 'Searching....',           
          timeout: 4200,         
        },         
        'Generating response...': {           
          messages: [             
            'Synthesizing findings to construct a meaningful response...',              
            'Processing a larger set of results to ensure accuracy...',              
            'Compiling the analyzed information into a clear response...',              
          ],
          // Rotated indefinitely once `messages` finishes — surfaced only
          // when the response is taking longer than the planned sequence so
          // the UI keeps showing fresh, on-topic progress copy. Falls back
          // to looping `messages` if this is omitted.
          rotate_messages: [
            'Refining the details for a comprehensive answer...',             
            'Cross-referencing data to enhance response quality...',             
            'Structuring the information for better clarity...',             
            'Reviewing the gathered insights for completeness...',             
            'Polishing the response to ensure relevance...',             
            'Finalizing the response for delivery...',
          ],         
          group: 'Generating response...',           
          timeout: 3600,         
        },         
        Complete: {          
          messages: ['Completing the final response...'],           
          group: 'Complete',           
          timeout: 1800,         
        },       
      },     
    },
    isQuickLoader:'',
    scrollToBottomStreaming: false,
    articlePreviewsTypingTimeouts: [],
    fallback_attempt_suggested:0,
    isAiChatStatusChangedMessage:'',
    isStartChatData:null,
    isClosingAssistantChat:false,
    isNewUiChatData:null,
    /** Engagement postMessage actions consumed by NewUiChatInput (start_chat / open_chat). */
    newUiEngagementAction: null,
    /** Engagement postMessage actions consumed by HomeAdvancedModalChat for v1 UI (start_chat / open_chat). */
    v1EngagementAction: null,
    /** Campaign attribution from modal:start_chat / modal:open_chat postMessages (requestChat). */
    campaign_ref: '',
    campaign_type: '',
    /** Dedupes modal:start_chat / modal:open_chat engagement actions (action.at). */
    lastProcessedNewUiEngagementAt: null,
    /** Dedupes v1 widget engagement actions (action.at). */
    lastProcessedV1EngagementAt: null,
    /** Prevents duplicate outbound engagement sends within a short window. */
    lastNewUiEngagementOutboundAt: null,
    /** Prevents duplicate v1 outbound engagement sends within a short window. */
    lastV1EngagementOutboundAt: null,
    /** True after widget_refreshed has loaded conversation messages into frontendMessages. */
    v1RestoreMessagesHydrated: false,
    /** Set by AdvancedWidget when sync finds no queue_ref to restore; HomeAdvancedModalChat consumes once */
    newUiNoPreviousConnectionWelcome: false,
    /** True while a no-connection welcome sequence is actively being appended (prevents concurrent runs across remounts). */
    newUiNoPreviousConnectionWelcomeRunning: false,
    /** New UI welcome "typing" dots — independent of isTyping (socket can clear isTyping on disconnect). */
    newUiWelcomeLocalTyping: false,
    widget_ref:'',
    isConnectedToAnotherTab: false,
    agentPromptHistoryForCopilot: [],
    copilotRequestInfoTrigger: null,
    addToComposerText: null,
    showFrontendImageDialog: false,
    frontendImageDialogSrc: '',
    widget_quick_prompts:{},
    widget_welcome_override:[],
    isGoogleTranslateEnabled:false,
    coverImage:'',
    query_presets:[],
    awaitingAiReplyAfterVisitorQuestion:false,
    aiChatStreamLoader: {
      completedMessages: [],
      activeMessage: null,
      groupingTier: null,
      completeHolding: false,
      completeHoldExpiresAt: 0,
      pendingHoldMessageIds: [],
    },
    isInboxDataLoading:false,
    agency_plan: null,
  },
  mutations: {
    openFrontendImageDialog(state, src) {
      state.frontendImageDialogSrc = src || '';
      state.showFrontendImageDialog = !!state.frontendImageDialogSrc;
    },
    setFrontendImageDialogVisible(state, visible) {
      state.showFrontendImageDialog = visible;
      if (!visible) {
        state.frontendImageDialogSrc = '';
      }
    },
    rerenderChats(state, { type }) {
      const currentKey = Number(state.renderChats?.key) || 0;
      state.renderChats = {
        type: type,
        key: currentKey + 1,
      };
    },
    updateSelectedItem(state, { key, payload }) {
      state[key] = payload;
    },
    clearConversationUnread(state, conversation_ref) {
      clearConversationUnreadState(state, conversation_ref);
    },
    setSelectedEnvironmentId(state, payload) {
      state.selectedEnvironmentId = payload;
    },
    setSelectedEnvironment(state, payload) {
      state.selectedEnvironment = payload;
      state.selectedEnvironmentId = payload?.id || null;
    },
    setEnvironments(state, payload) {
      const newEnvironments = payload || [];
      state.environments = newEnvironments;
      
      // Validate selectedEnvironment still exists
      if (state.selectedEnvironment) {
        const exists = newEnvironments.some(e => String(e.id) === String(state.selectedEnvironment?.id));
        if (!exists) {
          // Selected environment was deleted, set to primary or first available
          const fallbackEnv = getDefaultEnvironment(newEnvironments);
          if (fallbackEnv) {
            state.selectedEnvironment = fallbackEnv;
            state.selectedEnvironmentId = fallbackEnv.id || null;
          } else {
            // No environments available, clear selection
            state.selectedEnvironment = null;
            state.selectedEnvironmentId = null;
          }
        }
      }
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector('#app');

      if (sidenav_show.classList.contains('g-sidenav-show') && sidenav_show.classList.contains('g-sidenav-hidden')) {
        sidenav_show.classList.add('g-sidenav-pinned');
        sidenav_show.classList.remove('g-sidenav-hidden');
        state.isPinned = true;
      } else if (sidenav_show.classList.contains('g-sidenav-show') && sidenav_show.classList.contains('g-sidenav-pinned')) {
        sidenav_show.classList.add('g-sidenav-hidden');
        sidenav_show.classList.remove('g-sidenav-pinned');
        state.isPinned = false;
      } else if (sidenav_show.classList.contains('g-sidenav-show') && window.innerWidth < 1200) {
        sidenav_show.classList.add('g-sidenav-pinned');
        state.isPinned = true;
      } else {
        sidenav_show.classList.add('g-sidenav-hidden');
        state.isPinned = true;
      }
    },
    setSidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    toggleDefaultLayout(state) {
      state.showNavbar = !state.showNavbar;
      state.showSidenav = !state.showSidenav;
      state.showFooter = !state.showFooter;
    },
    setLastFailedArticleSearch(state, value) {
      state.lastFailedArticleSearch.id = value;
    },
    setLastSuccessArticleSearch(state, value) {
      state.lastSuccessArticleSearch.id = value;
    },
    setSearchedKeyword(state, value) {
      state.searchedKeyword.query = value;
    },
    setShowConversationDetails(state, value) {
      state.showConversationDetails_open = value;
    },
    scrollToBottom(state, value) {
      const params = new URLSearchParams(window.location.search);
      const loadGeneration = state.threadLoadGeneration;
      const finishThreadLoading = () => {
        if (state.threadLoadGeneration === loadGeneration) {
          state.isThreadLoading = false;
        }
      };
      const scrollToBottom = () => {
        const container = document.getElementById('conversation-window');
        // console.log('scrollToBottom 705', container) 
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      };
      const getUnreadMessages = () => {
        const tabs = {
          inbox: { selectedItem: state.selectedChat, storeKey: 'messages' },
          search: { selectedItem: state.selectedSearch, storeKey: 'selectedSearch' },
          archives: { selectedItem: state.selectedArchive, storeKey: 'selectedArchive' },
          tickets: { selectedItem: state.selectedTicket, storeKey: 'selectedTicket' },
          mentiontickets: { selectedItem: state.selectedMentionTicket, storeKey: 'selectedMentionTicket' },
          hlpttickets: { selectedItem: state.selectedHlptTicket, storeKey: 'selectedHlptTicket' },
          createdbyyoutickets: { selectedItem: state.selectedCreatedByYouTicket, storeKey: 'selectedCreatedByYouTicket' },
          othertickets: { selectedItem: state.selectedOtherTicket, storeKey: 'selectedOtherTicket' },
          reassignedtickets: { selectedItem: state.selectedReassignedTicket, storeKey: 'selectedReassignedTicket' },
          unassignedtickets: { selectedItem: state.selectedUnassignedTicket, storeKey: 'selectedUnassignedTicket' },
          awaitingreplytickets: { selectedItem: state.selectedAwaitingReplyTicket, storeKey: 'selectedAwaitingReplyTicket' },
          awaitingreplyhlpttickets: { selectedItem: state.selectedAwaitingReplyHlptTicket, storeKey: 'selectedAwaitingReplyHlptTicket' },
          drafts: { selectedItem: state.selectedDraft, storeKey: 'selectedDraft' },
        };

        const currentTab = params.get('tab');
        if (!currentTab || !tabs[currentTab]?.selectedItem) return;

        let selectedItem = tabs[currentTab].selectedItem;
        if (!selectedItem?.conversation_messages && !(currentTab === 'inbox' && state.messages[params.get('conversation_ref')])) return;

        let msgs = currentTab === 'inbox' ? (state.messages[params.get('conversation_ref')] ? JSON.parse(JSON.stringify(state.messages[params.get('conversation_ref')])) : []) : JSON.parse(JSON.stringify(selectedItem.conversation_messages)) || [];
        msgs = msgs.filter(el => el.sender_type !== 'agent' && el.read_status == 0);
        msgs = state.debugging_mode ? msgs : msgs.filter(el => el.sender_type !== 'system_debug');
        // console.log('msgs ', msgs)
        return msgs;
      };
      if (params.get('msgFocus')) {
        const msgFocus = params.get('msgFocus');
        const container = document.getElementById('conversation-window');
        if (container && msgFocus) {
          const target = document.querySelector(`#${msgFocus}`);
          if (target) {
            target.classList.add('highlight-effect'); // Add initial highlight effect
            // Use setTimeout to remove the highlight after a short delay
            setTimeout(() => {
              target.classList.add('highlight-effect-fade'); // Start fading the highlight
              setTimeout(() => {
                target.classList.remove('highlight-effect', 'highlight-effect-fade'); // Clean up classes
              }, 1000); // Remove classes after the transition ends
            }, 500); // Delay before starting the fade
            const scrollPosition = target.offsetTop;
            container.scrollTop = scrollPosition;
          }
        }
        setTimeout(() => {
          finishThreadLoading();
        }, 1000);
      } else  if (!state.isPreviousMessagesFetching) {
        if(params.get('tab') == 'mentiontickets' && state.mentionFilterBy == 'unread') {
          let container = document.getElementById('conversation-window');
          if(container) {
            const elements = document.querySelectorAll(`[uid='${state.user_id}']`)
            if(elements.length) {
              const target = elements[0].closest('.conversation-chat-card');
              if(target) {
                setTimeout(() => {
                  const scrollPosition = target.offsetTop;
                  container.scrollTop = scrollPosition;
                }, 500);
              } else {
                scrollToBottom();
              }
            } else {
              scrollToBottom();
            }
          }

          setTimeout(() => {
            finishThreadLoading();
          }, 1000);
        } else if (getUnreadMessages()?.length > 0 && state.isThreadLoading) {
          const target = document.querySelector(`#unread_flag_${getUnreadMessages()[0].id}`);
          const container = document.getElementById('conversation-window');
          if (target) {
            const scrollPosition = target.offsetTop;
            container.scrollTop = scrollPosition;
          } else {
            setTimeout(() => {
              scrollToBottom();
            }, 100);
          }
          setTimeout(() => {
            finishThreadLoading();
          }, 1000);
        } else {
          setTimeout(() => {
            scrollToBottom();
          }, 100);
          setTimeout(() => {
            finishThreadLoading();
          }, 1000);
        }
      }
    },
    seenMessages(state, value) {
      if (document.hidden) return;
      const tabs = {
        inbox: { messages: state.messages, selectedItem: state.selectedChat, individualKey: 'selectedChat', storeKey: 'inboxMembers' },
        tickets: { messages: state.selectedTicket?.conversation_messages, selectedItem: state.selectedTicket, individualKey: 'selectedTicket', storeKey: 'tickets' },
        archives: { messages: state.selectedArchive?.conversation_messages, selectedItem: state.selectedArchive, individualKey: 'selectedArchive', storeKey: 'archiveChats' },
        mentiontickets: { messages: state.selectedMentionTicket?.conversation_messages, selectedItem: state.selectedMentionTicket, individualKey: 'selectedMentionTicket', storeKey: 'mentionTickets' },
        createdbyyoutickets: { messages: state.selectedCreatedByYouTicket?.conversation_messages, selectedItem: state.selectedCreatedByYouTicket, individualKey: 'selectedCreatedByYouTicket', storeKey: 'createdByYouTickets' },
        drafts: { messages: state.selectedDraft?.conversation_messages, selectedItem: state.selectedDraft, individualKey: 'selectedDraft', storeKey: 'drafts' },
        search: { messages: state.selectedSearch?.conversation_messages, selectedItem: state.selectedSearch, individualKey: 'selectedSearch', storeKey: 'searchRecords' },
        hlpttickets: { messages: state.selectedHlptTicket?.conversation_messages, selectedItem: state.selectedHlptTicket, individualKey: 'selectedHlptTicket', storeKey: 'hlptTickets' },
        othertickets: { messages: state.selectedOtherTicket?.conversation_messages, selectedItem: state.selectedOtherTicket, individualKey: 'selectedOtherTicket', storeKey: 'otherTickets' },
        reassignedtickets: { messages: state.selectedReassignedTicket?.conversation_messages, selectedItem: state.selectedReassignedTicket, individualKey: 'selectedReassignedTicket', storeKey: 'reassignedTickets' },
        unassignedtickets: { messages: state.selectedUnassignedTicket?.conversation_messages, selectedItem: state.selectedUnassignedTicket, individualKey: 'selectedUnassignedTicket', storeKey: 'unassignedTickets' },
        awaitingreplytickets: { messages: state.selectedAwaitingReplyTicket?.conversation_messages, selectedItem: state.selectedAwaitingReplyTicket, individualKey: 'selectedAwaitingReplyTicket', storeKey: 'awaitingReplyTickets' },
        awaitingreplyhlpttickets: { messages: state.selectedAwaitingReplyHlptTicket?.conversation_messages, selectedItem: state.selectedAwaitingReplyHlptTicket, individualKey: 'selectedAwaitingReplyHlptTicket', storeKey: 'awaitingReplyHlptTickets' },
      };

      // A ref opened in the inbox tab can belong to a chat or to one of my tickets
      const resolveStoreKey = (tab, ref) => {
        if (tab === 'inbox' && state.inboxTickets.some(el => el?.conversation_ref?.toString() == ref?.toString())) {
          return 'inboxTickets';
        }
        return tabs[tab].storeKey;
      };

      const params = new URLSearchParams(window.location.search);

      const currentTab = params.get('tab');
      if(currentTab == 'archives') {
        return;
      }
      // console.log('currentTab ', currentTab)
      const conversationRef = params.get('conversation_ref');
      if (!currentTab || !conversationRef || !tabs[currentTab]?.selectedItem) return;

      let selectedItem = tabs[currentTab].selectedItem;
      // console.log('selectedItem ', selectedItem)
      let individualKey = tabs[currentTab].individualKey;
      // console.log('individualKey ', individualKey)
      if (currentTab === 'inbox' ? !(tabs[currentTab].messages[conversationRef] && tabs[currentTab].messages[conversationRef].length) : !(selectedItem.conversation_messages && selectedItem.conversation_messages.length)) {
        return;
      }

      let msgs = currentTab === 'inbox' ? state.messages[conversationRef].filter(el => (el.sender_type !== 'agent' || el.sender_type == 'note') && el.read_status === 0) : selectedItem.conversation_messages.filter(el => el.sender_type !== 'agent' && el.read_status === 0) || [];
      // console.log('msgs length', msgs)
      msgs = state.debugging_mode ? msgs : msgs.filter(el => el.sender_type !== 'system_debug');
      if (!msgs.length) {
        let lastmsg = currentTab === 'inbox' ? state.messages[conversationRef][state.messages[conversationRef].length - 1] : selectedItem.conversation_messages[selectedItem.conversation_messages.length - 1];
        if(lastmsg.read_status == 1) {
          let storeKey = resolveStoreKey(currentTab, conversationRef);
          let index = state[storeKey].findIndex(el => el.conversation_ref == conversationRef);
          if (index !== -1) {
            let stateData = state[storeKey];
            if(stateData[index]) {
              // console.log('stateData ', stateData[index])
              stateData[index] = {
                ...state[storeKey][index],
                unread_messages_count: 0,
              };
              if(currentTab !== 'inbox') {
                stateData[index] = {
                  ...state[storeKey][index],
                  conversation_messages:  state[storeKey][index].conversation_messages.map(el => ({ ...el, read_status: 1 })),
                }
              }
            }
          };
          clearConversationUnreadState(state, conversationRef);

          if (currentTab === 'inbox') {
            state?.messages[conversationRef]?.forEach(el => {
              if (el.read_status == 0) {
                el.read_status = 1;
              }
            });
          } else {
            if (state[individualKey]?.conversation_messages) {
              state[individualKey] = {
                ...selectedItem,
                unread_messages_count: 0,
                conversation_messages: state[individualKey].conversation_messages.map(el => ({ ...el, read_status: 1 })),
              };
            }
          }
        }
        return
      }

      let last_msg = msgs[msgs.length - 1];
      if (last_msg.read_status === 1) return;

      let message_id = last_msg?.id;
      if (!message_id) return;

      let payload = {
        action: 'messageUpdate',
        message_action: 'mark_as_seen',
        support_lib_id: state.support_lib_id,
        message_id,
        conversation_ref: selectedItem.conversation_ref,
        sender_type: 'agent',
      };

      // console.log('payload ', payload)

      if (state.socket) {
        state.isMarkingSeen = true;
        Api.sendApplicationWebSocket(payload);
        if (state.markAsSeenTimeOut) {
          clearTimeout(state.markAsSeenTimeOut);
          state.markAsSeenTimeOut = null;
        }
        state.markAsSeenTimeOut = setTimeout(() => {
          let storeKey = resolveStoreKey(currentTab, conversationRef);
          let index = state[storeKey].findIndex(el => el.conversation_ref == conversationRef);
          if (index !== -1) {
            let stateData = state[storeKey];
            if(stateData[index]) {
              stateData[index] = {
                ...state[storeKey][index],
                unread_messages_count: 0,
              };
              // console.log('stateData ', stateData[index])
              if(currentTab !== 'inbox') {
                stateData[index] = {
                  ...state[storeKey][index],
                  conversation_messages:  state[storeKey][index].conversation_messages.map(el => ({ ...el, read_status: 1 })),
                }
              }
              state[storeKey] = stateData;
            }
          }
          clearConversationUnreadState(state, conversationRef);
          if (currentTab === 'inbox') {
            state?.messages[conversationRef]?.forEach(el => {
              if (el.read_status == 0) {
                el.read_status = 1;
              }
            });
          } else {
            if (state[individualKey]?.conversation_messages) {
              state[individualKey] = {
                ...selectedItem,
                unread_messages_count: 0,
                conversation_messages: state[individualKey].conversation_messages.map(el => ({ ...el, read_status: 1 })),
              };
            }
          }

          state.markAsSeenTimeOut = null;
          setTimeout(() => {
            state.isMarkingSeen = false;
          }, 1000);
        }, 2000);
      }
    },
    removeToolTip() {
      document.querySelectorAll('.tooltip, .rx-tooltip').forEach((tooltip) => tooltip.remove());
    },
    disableParentScroll() {
      document.body.style.overflow = 'hidden'; // Disable parent scrolling
    },
    enableParentScroll() {
      document.body.style.overflow = ''; // Enable parent scrolling again
    },

    // Add new reports mutations
    setReports(state, payload) {
      // Only update if the number of reports has changed
      if (state.reports.allReports.length !== (payload.allReports?.length || 0)) {
        state.reports = {
          allReports: payload.allReports || [],
          lastUpdated: new Date().getTime(),
        };
      }
    },

    // Optional: Add individual report mutations if needed
    updateReport(state, payload) {
      const reportIndex = state.reports.allReports.findIndex(r => r.report_id === payload.report_id);
      if (reportIndex !== -1) {
        state.reports.allReports[reportIndex] = {
          ...state.reports.allReports[reportIndex],
          ...payload,
        };
      }
    },

    addReport(state, report) {
      state.reports.allReports.push(report);
    },
    toggleReportFavorite(state, reportId) {
      const report = state.reports.allReports.find(r => r.report_id === reportId);
      if (report) {
        report.report_favorite = report.report_favorite === 1 ? 0 : 1;
      }
    },
    removeReport(state, reportId) {
      state.reports.allReports = state.reports.allReports.filter(report => report.report_id !== reportId);
    },
  },
  actions: {
    updateShowConversationDetails({ commit }, value) {
      commit('setShowConversationDetails', value);
    },
    toggleSidebarColor({ commit }, payload) {
      commit('setSidebarType', payload);
    },
    async updateLastFailedArticleSearch(context, payload) {
      context.commit('setLastFailedArticleSearch', payload.data);
    },
    async updateLastSuccessArticleSearch(context, payload) {
      context.commit('setLastSuccessArticleSearch', payload.data);
    },
    async updateSearchedKeyword(context, payload) {
      // console.log('payload', payload)
      context.commit('setSearchedKeyword', payload);
    },
    markAsSeen(context, payload) {
      context.commit('seenMessages', '');
    },
    threadScrollToBottom(context) {
      context.commit('scrollToBottom', '');
    },
    printLog(context, payload) {
      let isDebugOn = localStorage.getItem('debug') === 'ON';
      if (payload?.type === 'error') {
        console.error(payload.text, ' ', moment.utc().format('LTS.SSS'), ' ', payload?.log ? payload?.log : '');
      } else if (payload?.type === 'warning') {
        console.warn(payload.text, ' ', moment.utc().format('LTS.SSS'), ' ', payload?.log ? payload?.log : '');
      } else {
        if (['staging', 'localhost'].some(urlVal => window.location.hostname.includes(urlVal)) || isDebugOn) {
          if (payload?.text) {
            console.log(payload?.text, ' ', moment.utc().format('LTS.SSS'), ' ', payload?.log ? payload?.log : '');
          } else {
            console.log(payload?.log ? payload?.log : '', ' ', moment.utc().format('LTS.SSS'));
          }
        }
      }
    },
    fetchPreviousMessages({ state, dispatch }, payload) {
      // 1. Set loading state
      state.isPreviousMessagesFetching = true;
    
      const containerClass = state.isStartChatData ? '.chatbox-height' : '.widget-advanced-content-chat';
      const chatContainer = document.querySelector(containerClass);
      let previousScrollHeight = 0;
      let previousScrollTop = 0;
    
      if (chatContainer) {
        // 2. Disable smooth scrolling immediately via class
        chatContainer.classList.add('no-smooth-scroll');
        previousScrollHeight = chatContainer.scrollHeight;
        previousScrollTop = chatContainer.scrollTop;
      }
    
      // 3. Determine visitor reference
      let visitor_ref = state.areThirdPartyCookiesEnabled
        ? localStorage.getItem('visitor_connection_visitor_ref')
        : state.visitor_connection_visitor_ref;
    
      if (!visitor_ref) {
        state.isPreviousMessagesFetching = false;
        state.fetchPreviousMessages = true;
        return;
      }
    
      // 4. Construct URL
      const url = `${inboxBaseURL}/messages?support_lib_id=${payload.library_key}&order=DESC&visitor_ref=${visitor_ref}`;
    
      axios
        .get(url)
        .then((res) => {
          if (res?.data?.conversations) {
            // 5. Update the messages (This triggers the DOM update)
            state.previousChat = res.data.conversations.reverse();
    
            // 6. Use requestAnimationFrame to "snap" scroll before the next paint
            requestAnimationFrame(() => {
              if (chatContainer) {
                const newScrollHeight = chatContainer.scrollHeight;
                const scrollDiff = newScrollHeight - previousScrollHeight;
    
                // Force the scroll position to maintain relative location
                chatContainer.scrollTop = previousScrollTop + scrollDiff;
    
                // 7. Cleanup: Remove the class to allow smooth scrolling again for user input
                // We use a tiny timeout to ensure the "snap" is finished
                setTimeout(() => {
                  chatContainer.classList.remove('no-smooth-scroll');
                }, 50);
              }
            });
          }
        })
        .catch((err) => {
          if (typeof state.dispatch === 'function') {
            state.dispatch('printLog', { text: 'Error fetching messages', log: err, type: 'error' });
          } else {
            console.error('An error occurred:', err);
          }
        })
        .finally(() => {
          state.isPreviousMessagesFetching = false;
          state.fetchPreviousMessages = true;
        });
    }
  },
  getters: {
    // ... existing getters ...

    isDemoModeAvailable: (state) => state.support_lib_id === process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID,

    isDemoMode: (state, getters) => getters.isDemoModeAvailable && state.demoMode,

    demoModeQueryParam: (state, getters) => {
      if (!getters.isDemoModeAvailable) {
        return '';
      }
      return getters.isDemoMode ? '&dm=1' : '&dm=0';
    },

    isDemoDataHidden: (state, getters) => getters.isDemoModeAvailable && !getters.isDemoMode,

    isStandAloneLibrary:(state) => {
      return state.support_lib_id !== process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID && 
      state.parent_lib_id !== process.env.VUE_APP_HLPT_PARENT_SUPPORT_LIB_ID;
    },
    // Add reports getters if needed
    getReportById: state => reportId => {
      return state.reports.allReports.find(report => report.report_id === reportId);
    },

    isAlertOn: (state, getters) => {
      return getters?.getNotificationDetails?.length > 0;
    },

    isDevMode: () => {
      return ['staging', 'localhost'].some(urlVal => window.location.hostname.includes(urlVal))
    },

    getNotificationDetails: state => {

      const location = router.currentRoute?.value?.path || window.location.pathname;
      const notifications = [];
      
      if(state.isUserLoggedIn && state.support_lib_id !== state.init_support_lib_id) {
        notifications.push({
          id: 'logged_in_as_a_child_agency',
        });
      }


      if(state.isConnectedToAnotherTab) {
        notifications.push({
          id: 'connection_switched_to_another_tab',
        });
      }

      if(state?.agent_role !== 'agent' &&   state?.chatStarted == false && location.includes('/admin/inbox')) {
        notifications.push({
          id: 'not_connected_to_modal',
        });
      }  

      if(state.socketStatus( state.socket) == 'closed') {
        notifications.push({
          id: 'connection_disconnected',
        });
      }

      if(state.isAgentProfileNotCompleted) {
        notifications.push({
          id: 'inbox_profile_not_set_up',
        });
      }
      if(state.autoAssignedChatThreads[state.autoAssignedChatThreads.length - 1]?.time) {
        notifications.push({
          id: 'new_auto_assigned_chats',
        });
      } 
      if(state.manualAssignedChatThreads[state.manualAssignedChatThreads.length - 1]?.time) {
        notifications.push({
          id: 'new_manual_assigned_chats',
        });
      }
      if(state.internet_connection !== '' &&  state.show_internet_alert) {
        notifications.push({
          id: 'internet_connection_offline',
        });
      }
      if( state.is_away == 1) {
        notifications.push({
          id: 'away_mode_enabled',
        });
      }
      
      return notifications.filter(el => ! state.ignoreNotificationIds.includes(el.id));
    },


    checkIsListTicketsTab() {
      let tabs = ['tickets', 'drafts', 'hlpttickets', 'othertickets', 'reassignedtickets', 'unassignedtickets', 'createdbyyoutickets', 'unassignedtickets', 'awaitingreplytickets', 'awaitingreplyhlpttickets']
      const params = new URLSearchParams(window.location.search);
      return tabs.includes(params.get('tab'))
  },
  

    getFavoriteReports: state => {
      return state.reports.favoriteReports;
    },


    translateElement : state => (translations, dataElement) => {
      const translationMap = Object.fromEntries(
        translations.map(t => [t.source.toLowerCase(), t.translation])
      );
      const pattern = new RegExp(
        `\\b(${translations.map(t => t.source).join('|')})\\b`, 
        'gi'
      );
      if (!dataElement) return null;

      // 2. Use a template element (lightweight, doesn't render)
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = dataElement;

      // 3. TreeWalker: The most efficient way to find text in HTML
      const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
      let node;

      while (node = walker.nextNode()) {
        // Only replaces text content, ignores all HTML tags and attributes
        node.nodeValue = node.nodeValue.replace(pattern, (matched) => {
          return translationMap[matched.toLowerCase()] || matched;
        });
      }

      return tempDiv.innerHTML;

     // if (dataElement) {
      //     let isReplaced = false;
  
      //     this.translations.forEach((elem, i) => {
      //       const searchRegExp = new RegExp(`\\b${elem.source}\\b`, 'gi');
      //       dataElement = dataElement.replaceAll(searchRegExp, elem.translation);
      //       if (i == this.translations.length - 1) {
      //         isReplaced = true;
      //       }
      //     });
  
      //     return isReplaced ? dataElement : null;
      //   }
    },

    dompurify: state => (text) => {
      const purify = (input) => {
        if (typeof input === 'string') {
          // Custom hooks to remove dangerous attributes and block dangerous src values
          const domPurifyConfig = {
            ADD_TAGS: ['iframe'],
            ADD_ATTR: [
              'allow', 
              'allowfullscreen', 
              'frameborder', 
              'scrolling', 
              'width', 
              'height', 
              'src', 
              'style', 
              '*',
              'sop_link',
              'article_link', 
              'support_lib_id', 
              'article_id', 
              'sop_id', 
              'conversation_id', 
              'course_id',
              'target',
            ],
            ALLOW_DATA_ATTR: true,
            // Only allow safe URI schemes (exclude javascript:, data:text/html, etc.)
            ALLOWED_URI_REGEXP: /.*/, // allow all URLs
            // ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|ftp|tel|sms|data:image\/[^;]{2,9};base64)[^"']*)?$/i,
            USE_PROFILES: { html: true },
            WHOLE_DOCUMENT: false,
            FORBID_TAGS: [],
            // Explicitly forbid dangerous attributes
            FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onmouseenter', 'onmouseleave', 'oninput', 'onchange', 'onpaste']
          };

          // Configure DOMPurify hooks only once
          if (!DOMPurify.__sanitizer_hooks_set) {
            DOMPurify.addHook('uponSanitizeElement', function(node, data) {
              // Remove <iframe src="javascript:..."> or any alert() in src/content
              if (node.tagName === 'IFRAME' || node.tagName === 'IMG') {
                if (node.hasAttribute('src')) {
                  const src = node.getAttribute('src') || '';
                  // Block src containing 'alert', 'javascript:', or suspicious code
                  if (
                    /javascript:/i.test(src) ||
                    /alert\s*\(/i.test(src)
                  ) {
                    node.removeAttribute('src');
                  }
                }
              }
            });

            DOMPurify.addHook('uponSanitizeAttribute', function(node, data) {
              // Remove any onerror or inline JS event attributes not covered by FORBID_ATTR
              if (data.attrName && data.attrName.toLowerCase().startsWith('on')) {
                data.keepAttr = false;
              }
              // Remove src attributes containing "alert(" or "javascript:"
              if (data.attrName && data.attrName === 'src' && data.attrValue && (
                  /javascript:/i.test(data.attrValue) ||
                  /alert\s*\(/i.test(data.attrValue))) {
                data.keepAttr = false;
              }
            });

            DOMPurify.__sanitizer_hooks_set = true;
          }

          let safe = DOMPurify.sanitize(input, domPurifyConfig);

          // Remove leading/trailing invisible characters
          safe = safe.replace(/^[\u200B-\u200D\uFEFF]+|[\u200B-\u200D\uFEFF]+$/g, '');
          return safe.trim();
        }
    
        if (Array.isArray(input)) {
          return input.map(item => purify(item));
        }
    
        if (typeof input === 'object' && input !== null) {
          return Object.keys(input).reduce((acc, key) => {
            acc[key] = purify(input[key]);
            return acc;
          }, {});
        }
    
        return input;
      };
    
      return purify(text);
    },    

     

    getReportsByType: state => type => {
      return type === 'HS' ? state.reports.HSIncludedReports : state.reports.PSIncludedReports;
    },
  },
});